var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-box" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.bill_info,
                expression: "bill_info"
              }
            ],
            staticClass: "header-text"
          },
          [
            _c("div", [
              _vm._v(
                "\n        账单编号:" +
                  _vm._s(_vm.bill_info.bill_id) +
                  "    账单时间:" +
                  _vm._s(_vm.bill_info.create_time) +
                  "    账单状态：\n        "
              ),
              _vm.bill_info.status == 8
                ? _c("span", { staticStyle: { color: "#f56c6c" } }, [
                    _vm._v(_vm._s(_vm.getBillStatus(_vm.bill_info.status)))
                  ])
                : _c("span", { staticStyle: { color: "#67c23a" } }, [
                    _vm._v(_vm._s(_vm.getBillStatus(_vm.bill_info.status)))
                  ]),
              _vm._v(
                "    涉及订数：" + _vm._s(_vm.bill_info.order_num) + "\n      "
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
        _c(
          "div",
          {
            staticStyle: {
              background: "#f3f3f3",
              height: "37px",
              "line-height": "37px",
              position: "relative"
            }
          },
          [
            _c("span", [
              _vm._v("回货单日期：" + _vm._s(_vm.bill_date.length) + "张")
            ]),
            _vm._v(" "),
            _vm.bill_info.status == 7 || _vm.bill_info.status == 8
              ? _c(
                  "div",
                  {
                    staticStyle: { position: "absolute", right: "0", top: "0" }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.normalBill(),
                            expression: "!normalBill()"
                          }
                        ],
                        attrs: { type: "warning", size: "small" },
                        on: { click: _vm.splitBill }
                      },
                      [_vm._v("拆分账单")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.normalBill(),
                expression: "!normalBill()"
              }
            ],
            staticStyle: { height: "50px", border: "1px solid #f3f3f3" }
          },
          [
            _vm.bill_info.status == 7 || _vm.bill_info.status == 8
              ? _c(
                  "el-checkbox-group",
                  {
                    staticStyle: { "margin-top": "15px" },
                    on: { change: _vm.dateChange },
                    model: {
                      value: _vm.model.date,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "date", $$v)
                      },
                      expression: "model.date"
                    }
                  },
                  _vm._l(_vm.bill_date, function(date) {
                    return _c(
                      "el-checkbox",
                      { key: date, attrs: { label: date } },
                      [_vm._v(_vm._s(date))]
                    )
                  }),
                  1
                )
              : _vm._l(_vm.bill_date, function(date, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: {
                        float: "left",
                        width: "100px",
                        height: "30px",
                        "line-height": "30px"
                      }
                    },
                    [_vm._v("\n        " + _vm._s(date) + "\n      ")]
                  )
                })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bill-goods" }, [
        _c(
          "div",
          {
            staticClass: "bill-goods-header",
            staticStyle: { position: "relative" }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.supply_info,
                    expression: "supply_info"
                  }
                ],
                staticStyle: { float: "left" }
              },
              [
                _vm._v(
                  "\n        商品列表    " +
                    _vm._s(_vm.supply_info.supply_name) +
                    "\n            " +
                    _vm._s(_vm.supply_info.pgname) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: { float: "left", position: "absolute", right: "0" }
              },
              [
                _c("el-input", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.normalBill(),
                      expression: "!normalBill()"
                    }
                  ],
                  staticStyle: { float: "left", width: "150px" },
                  attrs: { size: "small", placeholder: "代采订单" },
                  model: {
                    value: _vm.form.woid,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "woid", $$v)
                    },
                    expression: "form.woid"
                  }
                }),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { float: "left", width: "150px" },
                  attrs: { size: "small", placeholder: "商品货号" },
                  model: {
                    value: _vm.form.goods_no,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "goods_no", $$v)
                    },
                    expression: "form.goods_no"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.normalBill(),
                        expression: "!normalBill()"
                      }
                    ],
                    staticStyle: {
                      float: "left",
                      width: "100px",
                      "font-size": "14px"
                    }
                  },
                  [_vm._v("\n          回货单日期：\n        ")]
                ),
                _vm._v(" "),
                _c("el-date-picker", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.normalBill(),
                      expression: "!normalBill()"
                    }
                  ],
                  staticStyle: { float: "left", width: "150px" },
                  attrs: {
                    size: "small",
                    "value-format": "yyyy-MM-dd",
                    type: "date",
                    placeholder: "选择日期"
                  },
                  model: {
                    value: _vm.form.date,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "date", $$v)
                    },
                    expression: "form.date"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      float: "left",
                      "margin-top": "3px",
                      "padding-right": "10px"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { float: "left" },
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.search()
                          }
                        }
                      },
                      [_vm._v("搜索")]
                    ),
                    _vm._v(" "),
                    (_vm.bill_info.status == 7 || _vm.bill_info.status == 8) &&
                    !_vm.normalBill()
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { float: "left" },
                            attrs: { size: "small", type: "warning" },
                            on: { click: _vm.splitBill }
                          },
                          [_vm._v("拆分账单")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { float: "left" },
                        attrs: { size: "small", type: "success" },
                        on: {
                          click: function($event) {
                            return _vm.output(1)
                          }
                        }
                      },
                      [_vm._v("导出")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { float: "left" },
                        attrs: {
                          type: "text",
                          size: "small",
                          icon: _vm.collapse
                            ? "el-icon-arrow-down"
                            : "el-icon-arrow-up"
                        },
                        on: {
                          click: function($event) {
                            _vm.collapse = !_vm.collapse
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.collapse ? "收起" : "展开"))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.billGoods,
                expression: "billGoods"
              }
            ],
            attrs: { name: "el-zoom-in-top" }
          },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.collapse,
                    expression: "collapse"
                  }
                ],
                attrs: { data: _vm.billGoods }
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "finish_owe_time", label: "回货单日期" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "woid", label: "代采订单" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.redirectOrder(scope.row.woid)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.woid) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "", label: "商品图片" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            { staticStyle: { width: "100%", height: "100%" } },
                            [
                              _c("img", {
                                staticStyle: { width: "50px", height: "50px" },
                                attrs: { src: scope.row.goods_img[0] },
                                on: {
                                  click: function($event) {
                                    _vm.imgs = scope.row.goods_img
                                    _vm.showImg = true
                                  }
                                }
                              })
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "goods_name", label: "商品名称" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "goods_no", label: "货号" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "co_val", label: "颜色" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "si_val", label: "尺码" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "price", label: "代采单价" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "num", label: "实际开单" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.num) +
                                "/" +
                                _vm._s(
                                  parseFloat(
                                    Number(scope.row.num) *
                                      Number(scope.row.price)
                                  ).toFixed(2)
                                ) +
                                "\n            "
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                !_vm.normalBill()
                  ? _c("el-table-column", {
                      attrs: { prop: "cg_sir_num", label: "回货金额" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.caculator(scope.row, 0)) +
                                    "\n          "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2634231454
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.normalBill()
                  ? _c("el-table-column", {
                      attrs: { prop: "finish_owe_time", label: "入库日期" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.normalBill()
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "cg_sir_num",
                        label: "拆分数量",
                        width: "150"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm.bill_info.status == 7 ||
                                _vm.bill_info.status == 8
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: { "margin-right": "5px" }
                                      },
                                      [
                                        _c("el-input-number", {
                                          attrs: {
                                            size: "mini",
                                            min: 0,
                                            max: Number(scope.row.se_pay_num)
                                          },
                                          on: { change: _vm.splitNumChange },
                                          model: {
                                            value: scope.row.split_num,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "split_num",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.split_num"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2098193335
                      )
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "bill-goods-header" }, [
              _c(
                "div",
                { staticStyle: { width: "100%", "text-align": "right" } },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.getTotal) + "\n          "
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.normalBill(),
                          expression: "!normalBill()"
                        }
                      ],
                      attrs: { size: "mini" },
                      on: { click: _vm.clearSplitNum }
                    },
                    [_vm._v("\n            数量清零\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.normalBill(),
                          expression: "!normalBill()"
                        }
                      ],
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.selectAllNum }
                    },
                    [_vm._v("数量全选")]
                  )
                ],
                1
              )
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "bill-goods" }, [
        _c(
          "div",
          {
            staticClass: "bill-goods-header",
            staticStyle: { position: "relative" }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.supply_info,
                    expression: "supply_info"
                  }
                ],
                staticStyle: { float: "left" }
              },
              [
                _vm._v(
                  "\n        商品列表(新)    " +
                    _vm._s(_vm.supply_info.supply_name) +
                    "\n            " +
                    _vm._s(_vm.supply_info.pgname) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: { float: "left", position: "absolute", right: "0" }
              },
              [
                _c("el-input", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.normalBill(),
                      expression: "!normalBill()"
                    }
                  ],
                  staticStyle: { float: "left", width: "150px" },
                  attrs: { size: "small", placeholder: "代采订单" },
                  model: {
                    value: _vm.form.new_woid,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "new_woid", $$v)
                    },
                    expression: "form.new_woid"
                  }
                }),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { float: "left", width: "150px" },
                  attrs: { size: "small", placeholder: "商品货号" },
                  model: {
                    value: _vm.form.new_goods_no,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "new_goods_no", $$v)
                    },
                    expression: "form.new_goods_no"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.normalBill(),
                        expression: "!normalBill()"
                      }
                    ],
                    staticStyle: {
                      float: "left",
                      width: "100px",
                      "font-size": "14px"
                    }
                  },
                  [_vm._v("\n          回货单日期：\n        ")]
                ),
                _vm._v(" "),
                _c("el-date-picker", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.normalBill(),
                      expression: "!normalBill()"
                    }
                  ],
                  staticStyle: { float: "left", width: "150px" },
                  attrs: {
                    size: "small",
                    "value-format": "yyyy-MM-dd",
                    type: "date",
                    placeholder: "选择日期"
                  },
                  model: {
                    value: _vm.form.new_date,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "new_date", $$v)
                    },
                    expression: "form.new_date"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { float: "left", "margin-top": "3px" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { float: "left" },
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.search()
                          }
                        }
                      },
                      [_vm._v("搜索")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.plan_order_goods,
                expression: "plan_order_goods"
              }
            ]
          },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.plan_order_goods.list } },
              [
                _c("el-table-column", {
                  attrs: { prop: "woid", label: "代采订单" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.redirectOrder(scope.row.woid)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.woid) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "", label: "代采计划" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("p", [_vm._v(_vm._s(scope.row.planid))]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(scope.row.wcg_plan_ptype))]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(scope.row.create_time))]),
                          _vm._v(" "),
                          _c("p", { staticStyle: { color: "red" } }, [
                            _vm._v(_vm._s(scope.row.goods_type))
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "", label: "商品图片" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            { staticStyle: { width: "100%", height: "100%" } },
                            [
                              _c("img", {
                                staticStyle: { width: "50px", height: "50px" },
                                attrs: { src: scope.row.main_img },
                                on: {
                                  click: function($event) {
                                    _vm.imgs = scope.row.middle_img
                                    _vm.showImg = true
                                  }
                                }
                              })
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "goods_name", label: "商品名称" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "goods_no", label: "货号" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "co_val", label: "颜色" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "si_val", label: "尺码" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "num", label: "开单数量" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "price", label: "代采价" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "total", label: "开单价小计" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "activity_fee", label: "活动服务费小计" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "", label: "佣金小计" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(scope.row.service_fee) +
                                "(" +
                                _vm._s(scope.row.service_rate) +
                                "%)"
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "dispense_commission_amount",
                    label: "小店佣金",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "", label: "退货服务费小计" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(scope.row.refund_service_fee) +
                                "(" +
                                _vm._s(scope.row.refund_service_rate) +
                                "%)"
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "price", label: "实际支付件/小计" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(scope.row.num) +
                                "/" +
                                _vm._s(scope.row.true_total)
                            )
                          ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "bill-goods-header" }, [
              _c(
                "div",
                { staticStyle: { width: "100%", "text-align": "right" } },
                [
                  _vm._v(
                    "\n          开单\n          " +
                      _vm._s(
                        _vm.plan_order_goods &&
                          _vm.plan_order_goods.total &&
                          _vm.plan_order_goods.total_num
                      ) +
                      "件,¥" +
                      _vm._s(
                        _vm.plan_order_goods &&
                          _vm.plan_order_goods.total &&
                          _vm.plan_order_goods.total.price
                      ) +
                      ",合计实付金额:" +
                      _vm._s(
                        _vm.plan_order_goods &&
                          _vm.plan_order_goods.total &&
                          _vm.plan_order_goods.total.pay_price
                      ) +
                      "\n        "
                  )
                ]
              )
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-item" },
        [
          _c("div", { staticClass: "header-text" }, [
            _vm._v(
              "\n      活动服务费商品 共" +
                _vm._s(_vm.activity_fee_detail.total_kh) +
                "款，" +
                _vm._s(_vm.activity_fee_detail.total_num) +
                "件，计￥" +
                _vm._s(_vm.activity_fee_detail.total_amout) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.activity_fee_detail.list,
                "span-method": _vm.rowSpan,
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "special_start_time",
                  label: "专场开始时间",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "woid", label: "代采订单号", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goods_name",
                  label: "商品名称",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "goods_no", label: "货号", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "co_val", label: "颜色", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "si_val", label: "尺码", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "plan_price",
                  label: "拿货单价",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "num", label: "开单数量", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "activity_time",
                  label: "活动时间",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "activity_id", label: "活动ID", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "activity_type",
                  label: "活动类型",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "activity_name",
                  label: "活动名称",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "discount_shop_price",
                  label: "小计",
                  align: "center"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.bill_info.status != 7 && _vm.bill_info.status != 8,
              expression: "bill_info.status != 7 && bill_info.status != 8"
            }
          ],
          staticClass: "page-item"
        },
        [
          _c(
            "div",
            {
              staticClass: "header-text",
              staticStyle: { position: "relative" }
            },
            [
              _vm._v(
                "\n      已选抵扣商品   " + _vm._s(_vm.getDedTotal) + "\n      "
              ),
              _c(
                "div",
                { staticStyle: { position: "absolute", right: "0", top: "0" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "success" },
                      on: {
                        click: function($event) {
                          return _vm.output(2)
                        }
                      }
                    },
                    [_vm._v("\n          导出\n        ")]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "0" } },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    border: "",
                    data: _vm.used_ded,
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "woiid",
                      label: "代采订单",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    return _vm.redirectOrder(scope.row.woid)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.woid) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "referer_type",
                      label: "来源",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cg_type",
                      label: "交易方式",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods_img",
                      label: "商品图片",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: { width: "50px", height: "50px" }
                              },
                              [
                                _c("img", {
                                  directives: [
                                    { name: "viewer", rawName: "v-viewer" }
                                  ],
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%"
                                  },
                                  attrs: { src: scope.row.goods_img[0] }
                                })
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods_name",
                      label: "商品名称",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods_no",
                      label: "商品货号",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods_kh",
                      label: "商品款号",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "co_val", label: "颜色", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "si_val", label: "尺码", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "price", label: "代采单价", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: "数量", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: "小计", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  parseFloat(
                                    Number(scope.row.num) *
                                      Number(scope.row.price)
                                  ).toFixed(2)
                                ) +
                                "\n          "
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "page-item" }, [
        _c(
          "div",
          { staticClass: "header-text", staticStyle: { position: "relative" } },
          [
            _vm._v(
              "\n      活动费抵扣商品   " +
                _vm._s(_vm.getActiveGoodsTotal) +
                "\n      "
            ),
            _c(
              "div",
              { staticStyle: { position: "absolute", right: "0", top: "0" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "success" },
                    on: { click: _vm.exportActivityGoods }
                  },
                  [_vm._v("\n          导出\n        ")]
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "margin-bottom": "0" } },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.activityGoodsInfo, border: "" } },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "活动时间",
                    prop: "activity_time",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "商品名称",
                    prop: "goods_name",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "货号", prop: "goods_no", align: "center" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "颜色/尺码", prop: "co_si", align: "center" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "SKU编号", prop: "sku", align: "center" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "单件优惠额",
                    prop: "activity_fee",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "抵扣数量", prop: "num", align: "center" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "订单ID", prop: "order_id", align: "center" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "活动ID",
                    prop: "activity_id",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "活动类型",
                    prop: "activity_type_text",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "活动名称",
                    prop: "activity_name",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "活动费抵扣小计",
                    prop: "activity_fee_amount",
                    align: "center"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-item" }, [
        _c("div", { staticClass: "header-text" }, [
          _vm._v("让利佣金账单抵扣明细")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "margin-bottom": "0" } },
          [
            _c(
              "el-table",
              {
                attrs: {
                  border: "",
                  data: _vm.rebateData.list,
                  "tooltip-effect": "dark"
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "reporting_period",
                    label: "让利账期",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "bill_no",
                    label: "让利账单编号",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "confirm_time",
                    label: "让利账单确认时间",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "amount_price",
                    label: "总结算金额",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "deduction_price",
                    label: "本单抵扣金额",
                    align: "center"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "right",
                  height: "40px",
                  background: "#f3f3f3",
                  "line-height": "40px",
                  padding: "0 40px",
                  "font-size": "14px",
                  color: "#ff4040"
                }
              },
              [
                _vm._v(
                  "\n        合计让利佣金抵扣金额： ¥" +
                    _vm._s(_vm.rebateData.total) +
                    "\n      "
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-item" }, [
        _c("div", { staticClass: "header-text" }, [_vm._v("金额明细")]),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "margin-bottom": "0" } },
          [
            _c(
              "el-table",
              {
                attrs: {
                  border: "",
                  data: [_vm.bill_info],
                  "tooltip-effect": "dark"
                }
              },
              [
                _c(
                  "el-table-column",
                  {
                    attrs: {
                      prop: "total_amount",
                      label: "开单价合计",
                      align: "center"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.total_amount) + "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "activity_price",
                    label: "活动服务费合计",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "service_fee",
                    label: "平台佣金合计",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "dispense_commission_amount",
                    label: "小店佣金",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "refund_service_fee",
                    label: "退货服务费合计",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "real_pay_amount",
                    label: "实付金额合计",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.true_price) +
                              "\n          "
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "ded_activity_fee",
                    label: "活动费用抵扣金额",
                    "show-overflow-tooltip": "",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "return_profit_fee",
                    label: "让利佣金抵扣金额",
                    "show-overflow-tooltip": "",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "reject_pay",
                    label: "可选抵扣商品",
                    "show-overflow-tooltip": "",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                Number(_vm.caculatorDed().num) -
                                  Number(_vm.dedData.num)
                              ) +
                              "/" +
                              _vm._s(
                                parseFloat(
                                  Number(_vm.caculatorDed().amount) -
                                    Number(_vm.dedData.amount)
                                ).toFixed(2)
                              ) +
                              "\n          "
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "ded_num",
                    label: "已选抵扣商品",
                    "show-overflow-tooltip": "",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.dedData.num) +
                              " / " +
                              _vm._s(_vm.dedData.amount) +
                              "\n            "
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.bill_info.status == 7 ||
                                      _vm.bill_info.status == 8) &&
                                    !_vm.normalBill(),
                                  expression:
                                    "\n                (bill_info.status == 7 || bill_info.status == 8) &&\n                !normalBill()\n              "
                                }
                              ],
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showDed = true
                                }
                              }
                            },
                            [_vm._v("选择抵扣\n            ")]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "need_num",
                    label: "结算时7天配货率",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("p", { staticStyle: { margin: "0" } }, [
                            _vm._v(
                              "\n              48小时配货率" +
                                _vm._s(
                                  Number(_vm.bill_info.first_target_rate) * 100
                                ) +
                                "%\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticStyle: { margin: "0" } }, [
                            _vm._v(
                              "\n              最终配货率" +
                                _vm._s(
                                  Number(_vm.bill_info.second_target_rate) * 100
                                ) +
                                "%\n            "
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "need_num",
                    label: "冻结金额（%）",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.bill_info.freeze_amount) +
                              " (" +
                              _vm._s(Number(_vm.bill_info.freeze_rate) * 100) +
                              "%)\n          "
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "real_pay_amount",
                    label: "实际结算金额",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.bill_info.real_pay_amount) +
                              "\n          "
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.bill_info.status == 7 || _vm.bill_info.status == 8,
              expression: "bill_info.status == 7 || bill_info.status == 8"
            }
          ],
          staticClass: "page-item"
        },
        [
          _c(
            "div",
            { staticClass: "header-text" },
            [
              _vm._v("\n      收款人信息\n      "),
              _vm.bill_info.pay_tool == 2
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.submitBill }
                    },
                    [_vm._v("提交账单")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "0" } },
            [
              _vm.bill_info.pay_tool != 2
                ? _c(
                    "el-table",
                    {
                      attrs: {
                        "span-method": _vm.objectSpanMethod,
                        border: "",
                        data: _vm.bank_info,
                        "tooltip-effect": "dark"
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "payee_name",
                          label: "选择",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: { label: scope.row.payee_id },
                                      model: {
                                        value: _vm.form.payee_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "payee_id", $$v)
                                        },
                                        expression: "form.payee_id"
                                      }
                                    },
                                    [_vm._v(_vm._s(""))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1224057589
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "payee_name",
                          label: "收款人名称",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "payee_bank",
                          label: "收款银行",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "cnap_name",
                          label: "收款银行支行",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "payee_bank_account",
                          label: "收款账号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "need_num",
                          label: "操作",
                          "show-overflow-tooltip": "",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success", size: "mini" },
                                      on: { click: _vm.submitBill }
                                    },
                                    [
                                      _vm._v(
                                        "\n              提交账单\n            "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4224293103
                        )
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.bill_info.status != 7 && _vm.bill_info.status != 8,
              expression: "bill_info.status != 7 && bill_info.status != 8"
            }
          ],
          staticClass: "page-item"
        },
        [
          _c("div", { staticClass: "header-text" }, [_vm._v("收款人信息")]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "0" } },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    border: "",
                    data: _vm.nullData,
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "pay_contact",
                      label: "收款人名称",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.bill_info.bank_is_verify == 1
                              ? _c(
                                  "el-tag",
                                  {
                                    staticStyle: {
                                      size: "mini",
                                      color: "#0e0e0e"
                                    },
                                    attrs: { type: "warning" }
                                  },
                                  [_vm._v("已验证")]
                                )
                              : _vm._e(),
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.pay_contact) +
                                "\n          "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pay_bank",
                      label: "收款银行",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cnap_name",
                      label: "收款银行支行",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pay_account",
                      label: "收款账号",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.bill_info.status == 2 ? "付款回执" : "操作",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.bill_info.status == 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "success"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.passBill()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                通过\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.normalBill(),
                                            expression: "!normalBill()"
                                          }
                                        ],
                                        attrs: { size: "mini", type: "danger" },
                                        on: {
                                          click: function($event) {
                                            return _vm.rejectBill()
                                          }
                                        }
                                      },
                                      [_vm._v("驳回")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.bill_info.status == 4 &&
                            _vm.bill_info.pay_tool != 2
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.update_payee(
                                              "",
                                              _vm.bill_info
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("修改付款信息")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.bill_info.status == 1 &&
                            _vm.bill_info.pay_tool != 2
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "flex-direction": "column"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "row"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            staticClass: "upload-demo",
                                            attrs: {
                                              action: _vm.action,
                                              multiple: "",
                                              "show-file-list": false,
                                              "on-success": _vm.handleSuccess,
                                              limit: 10,
                                              "with-credentials": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "primary"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    上传回执(" +
                                                    _vm._s(
                                                      _vm.form.docs.length
                                                    ) +
                                                    ")\n                  "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "margin-left": "20px !important"
                                            },
                                            attrs: {
                                              disabled:
                                                _vm.form.docs.length > 0
                                                  ? false
                                                  : true,
                                              type: "success",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.submitPayDoc()
                                              }
                                            }
                                          },
                                          [_vm._v("完成\n                ")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.normalBill(),
                                                expression: "!normalBill()"
                                              }
                                            ],
                                            attrs: {
                                              size: "mini",
                                              type: "danger"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.rejectBill()
                                              }
                                            }
                                          },
                                          [_vm._v("驳回")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.form.docs.length > 0,
                                            expression: "form.docs.length > 0"
                                          }
                                        ],
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "row",
                                          "margin-top": "10px"
                                        }
                                      },
                                      _vm._l(_vm.form.docs, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: item,
                                            staticStyle: {
                                              width: "50px",
                                              height: "50px",
                                              position: "relative"
                                            }
                                          },
                                          [
                                            _c("div", {
                                              staticClass: "el-icon-close",
                                              staticStyle: {
                                                color: "red",
                                                "font-size": "18px",
                                                "margin-right": "10px",
                                                position: "absolute",
                                                width: "15px",
                                                height: "15px",
                                                right: "-5px",
                                                top: "-5px",
                                                cursor: "pointer"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.delImg(index)
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("img", {
                                              directives: [
                                                {
                                                  name: "viewer",
                                                  rawName: "v-viewer"
                                                }
                                              ],
                                              staticStyle: {
                                                width: "100%",
                                                height: "100%"
                                              },
                                              attrs: { src: item }
                                            })
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.bill_info.pay_tool != 2,
                                    expression: "bill_info.pay_tool != 2"
                                  }
                                ],
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "row"
                                }
                              },
                              [
                                _vm.bill_info.status == 2
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-direction": "row"
                                        }
                                      },
                                      _vm._l(_vm.docList, function(item) {
                                        return _c("img", {
                                          key: item,
                                          staticStyle: {
                                            width: "50px",
                                            height: "50px"
                                          },
                                          attrs: { src: item },
                                          on: {
                                            click: function($event) {
                                              _vm.imgs = _vm.docList
                                              _vm.showImg = true
                                            }
                                          }
                                        })
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.bill_info.status == 2
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: { "margin-left": "30px" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.form.docs.length > 0,
                                                expression:
                                                  "form.docs.length > 0"
                                              }
                                            ],
                                            staticStyle: {
                                              display: "flex",
                                              "flex-direction": "row",
                                              "margin-top": "10px"
                                            }
                                          },
                                          _vm._l(_vm.form.docs, function(
                                            item,
                                            index
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: item,
                                                staticStyle: {
                                                  width: "50px",
                                                  height: "50px",
                                                  position: "relative"
                                                }
                                              },
                                              [
                                                _c("div", {
                                                  staticClass: "el-icon-close",
                                                  staticStyle: {
                                                    color: "red",
                                                    "font-size": "18px",
                                                    "margin-right": "10px",
                                                    position: "absolute",
                                                    width: "15px",
                                                    height: "15px",
                                                    right: "-5px",
                                                    top: "-5px",
                                                    cursor: "pointer"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.delImg(index)
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("img", {
                                                  directives: [
                                                    {
                                                      name: "viewer",
                                                      rawName: "v-viewer"
                                                    }
                                                  ],
                                                  staticStyle: {
                                                    width: "100%",
                                                    height: "100%"
                                                  },
                                                  attrs: { src: item }
                                                })
                                              ]
                                            )
                                          }),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "flex-direction": "row"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-upload",
                                              {
                                                staticClass: "upload-demo",
                                                attrs: {
                                                  action: _vm.action,
                                                  multiple: "",
                                                  "show-file-list": false,
                                                  "on-success":
                                                    _vm.handleSuccess,
                                                  accept: "image/*",
                                                  limit: 10,
                                                  "with-credentials": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      type: "primary"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      修改回执(" +
                                                        _vm._s(
                                                          _vm.form.docs.length
                                                        ) +
                                                        ")\n                    "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  "margin-left":
                                                    "20px !important"
                                                },
                                                attrs: {
                                                  disabled:
                                                    _vm.form.docs.length > 0
                                                      ? false
                                                      : true,
                                                  type: "success",
                                                  size: "mini"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.editPayDoc.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "完成\n                  "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.bill_info.status == 4 || _vm.bill_info.status == 11
        ? _c(
            "el-row",
            [
              _c("div", { staticClass: "card-title" }, [_vm._v("审核信息")]),
              _vm._v(" "),
              _vm.bill_info.pay_fail_msg.length > 0
                ? _c("div", { staticClass: "card-warning" }, [
                    _vm._v(
                      "\n      " + _vm._s(_vm.bill_info.pay_fail_msg) + "\n    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { border: "1px solid #ddd", padding: "15px" } },
                [
                  _c(
                    "el-col",
                    { staticStyle: { height: "200px" }, attrs: { span: 20 } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 9,
                          placeholder: "暂无备注信息"
                        },
                        model: {
                          value: _vm.textarea,
                          callback: function($$v) {
                            _vm.textarea = $$v
                          },
                          expression: "textarea"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticStyle: { height: "200px" }, attrs: { span: 4 } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            "justify-content": "space-around",
                            "align-items": "center",
                            height: "100%"
                          }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn-operation",
                                  attrs: { type: "success" },
                                  on: {
                                    click: function($event) {
                                      return _vm.repay(_vm.bill_info)
                                    }
                                  }
                                },
                                [_vm._v("重新激活")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.normalBill(),
                                      expression: "!normalBill()"
                                    }
                                  ],
                                  staticStyle: { size: "medium" },
                                  attrs: { type: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.rejectBill()
                                    }
                                  }
                                },
                                [_vm._v("驳回")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "page-item" }, [
        _c("div", { staticClass: "header-text" }, [_vm._v("操作日志")]),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "margin-bottom": "0" } },
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: { border: "", data: _vm.log, "tooltip-effect": "dark" }
              },
              [
                _c("el-table-column", {
                  attrs: { label: "操作人", prop: "operator", align: "center" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "action_type",
                    label: "操作方式",
                    "show-overflow-tooltip": "",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "create_time",
                    label: "操作时间",
                    "show-overflow-tooltip": "",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "action_result",
                    label: "操作备注",
                    "show-overflow-tooltip": "",
                    align: "center"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.showDed
        ? _c("select-ded-goods", {
            attrs: {
              used_ded: _vm.used_ded,
              "an-arr": _vm.anArr,
              ded_goods: _vm.ded_goods
            },
            on: { closeDialog: _vm.closeDialog }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.UpdatePayeeVisible
        ? _c(
            "div",
            [
              _c("update-payee", {
                attrs: {
                  id: _vm.$route.params.bill_id,
                  payee: _vm.payee,
                  url: _vm.url2
                },
                on: { onCloseDialog: _vm.onCloseDialog }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showImg
        ? _c("preview-image", {
            attrs: { show: _vm.showImg, imgs: _vm.imgs },
            on: { closeBox: _vm.closeImg }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c_page-title" }, [
      _c("div", [_vm._v("账单详情")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11b3e708", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b3e708","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supplybill/OkSupplyBillDetail.vue
// module id = null
// module chunks = 